import React, { useState } from "react";

const availability = [
  "Remote full-time opportunities",
  "Remote contract projects",
  "Remote technical consulting",
];

const fieldClass =
  "w-full border-0 border-b-2 border-ink bg-transparent px-0 py-3 font-serif text-lg text-ink placeholder:text-ink/60 focus:border-paper focus:outline-none focus:ring-0";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link
    const subject = `Portfolio Contact from ${formData.name}`;
    const body = `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`;
    const mailtoLink = `mailto:contact@garrettfreeman.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="mx-auto max-w-page px-5 py-16 md:px-10 md:py-24">
      <div className="flex items-baseline justify-between gap-6 border-b-2 border-ink pb-4">
        <h2 className="display font-serif text-4xl font-semibold tracking-tight md:text-6xl">
          Contact
        </h2>
        <p className="label">04 / Get in touch</p>
      </div>

      <div className="mt-10 grid gap-14 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-6">
          <a
            href="mailto:contact@garrettfreeman.com"
            className="block font-serif text-[clamp(1.5rem,6.5vw,2.5rem)] font-semibold leading-tight underline decoration-2 underline-offset-[0.2em] transition-colors hover:text-paper"
          >
            contact@<wbr />garrettfreeman.com
          </a>

          <dl className="mt-10 space-y-6">
            <div>
              <dt className="label">Open to</dt>
              <dd className="mt-2 text-lg leading-snug">
                <ul>
                  {availability.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </dd>
            </div>
            <div>
              <dt className="label">Location</dt>
              <dd className="mt-2 text-lg">Brookings, SD 57006</dd>
            </div>
            <div>
              <dt className="label">Elsewhere</dt>
              <dd className="mt-2 flex gap-6 font-mono text-sm">
                <a
                  href="https://www.linkedin.com/in/garrett-freeman/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline decoration-1 underline-offset-4 hover:text-paper"
                >
                  LinkedIn
                </a>
                <a
                  href="https://github.com/Garrett-Freeman"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline decoration-1 underline-offset-4 hover:text-paper"
                >
                  GitHub
                </a>
              </dd>
            </div>
          </dl>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 md:col-span-5 md:col-start-8">
          <p className="label">Or leave a note</p>
          <label className="block">
            <span className="sr-only">Your name</span>
            <input
              name="name"
              placeholder="Your name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className={fieldClass}
            />
          </label>
          <label className="block">
            <span className="sr-only">Your email</span>
            <input
              name="email"
              type="email"
              placeholder="Your email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className={fieldClass}
            />
          </label>
          <label className="block">
            <span className="sr-only">Message</span>
            <textarea
              name="message"
              placeholder="What are you working on?"
              rows={4}
              value={formData.message}
              onChange={handleInputChange}
              required
              className={`${fieldClass} resize-none`}
            />
          </label>
          <div className="flex flex-wrap items-center gap-4">
            <button
              type="submit"
              className="bg-ink px-6 py-3 font-mono text-sm text-paper transition-colors hover:bg-paper hover:text-ink"
            >
              Send message →
            </button>
            <p className="font-mono text-xs">Opens your email client, pre-filled.</p>
          </div>
        </form>
      </div>

      <footer className="mt-20 flex flex-wrap justify-between gap-4 border-t-2 border-ink pt-6 font-mono text-xs">
        <p>© {new Date().getFullYear()} Garrett Freeman</p>
        <p>Set in Fraunces &amp; IBM Plex Mono</p>
      </footer>
    </div>
  );
}
